const TourConstants = {
  INIT: 'TourConstants.INIT',
  NEXT_STEP: 'TourConstants.NEXT_STEP',
  FINISH: 'TourConstants.FINISH',
  JUMP: 'TourConstants.JUMP',
};

export default TourConstants;
